import office from '@/taskpane/officejs/office-wrapper'
import state from '@/taskpane/state/sidebar-state'
import { MailItemOpenArgs } from '../messages/send-item-open-message-mail'
import { EventItemOpenArgs } from '../messages/send-item-open-message-event'

import SubjectObserver from './subject-observer'
import AttachmentsObserver from './attachment-observer'
import RecipientsObserver from './recipients-observer'
import EmailBodyObserver from './email-body-observer'
import AppointmentBodyObserver from './appointment-body-observer'
import AppointmentTimeObserver from './appointment-time-observer'

export function observeMailComposeChanges(args: MailItemOpenArgs) {
  state.currentItem.composeInfo.initializeComposeInterval()

  state.currentItem.composeInfo.subject.attach(new SubjectObserver(), args.threads[0].subject)
  state.currentItem.composeInfo.attachments.attach(new AttachmentsObserver(), args.threads[0].attachments)
  state.currentItem.composeInfo.recipients.attach(new RecipientsObserver(), args.people as Office.EmailAddressDetails[])
  state.currentItem.composeInfo.emailBody.attach(new EmailBodyObserver())
}

export async function observeEventComposeChanges(args: EventItemOpenArgs) {
  state.currentItem.composeInfo.initializeComposeInterval()

  state.currentItem.composeInfo.subject.attach(new SubjectObserver(), args.eventInfo.title)
  state.currentItem.composeInfo.attachments.attach(new AttachmentsObserver(), args.eventInfo.attachments)
  state.currentItem.composeInfo.appointmentTime.attach(new AppointmentTimeObserver(), args.eventInfo.time)
  state.currentItem.composeInfo.appointmentBody.attach(new AppointmentBodyObserver(), await office.body.get(false, null))
  state.currentItem.composeInfo.recipients.attach(new RecipientsObserver(), args.people as Office.EmailAddressDetails[])
}
